export const formUrl = (
  inputUrl: string,
  // biome-ignore lint/suspicious/noExplicitAny: this will be refactored
  params: any,
): string => {
  const queryStrings = new URLSearchParams(params);
  const url = decodeURIComponent(
    `${inputUrl}?${queryStrings}`.replace(/\+/g, ' '),
  );
  return url;
};
